<template>
  <!--  <lazy-dom>-->
  <div class="policy-form">
    <el-form
      ref="form"
      :rules="rules"
      :model="formData">

      <div class="box border-none">
        <h3>Policyholder Details</h3>
        <policy-holder
          v-if="isAttachCustomer"
          ref="policy-holder"
          is-new-sme
          :form="formData"
          :formDataLock="cusFormDataLock"
          disabled
          :isEdit="isEdit"
          :form-data-lock="formDataLock"
          @getFormData="getSubimitForm"></policy-holder>
        <template v-if="!isQuote">
          <template v-if="!isAttachCustomer">
            <div class="flex-align-center mg-b-20">
              <span class="circle-icon">
                <font-awesome-icon
                  class="fs-14"
                  icon="exclamation"></font-awesome-icon>
              </span>
              <span>
                <p class="fw-600 fs-14 color-dark">{{form.isrd_com_nm}} Company</p>
                <p class="fw-400 fs-14 color-dark">{{form.email}}</p>
              </span>
            </div>
            <el-form-item>
              <v-button
                icon="plus"
                green
                @click="handleAddCustomer">
                Attach Customer
              </v-button>
            </el-form-item>
          </template>
          <v-button
            v-else
            class="mg-t-20"
            blue
            icon="pen"
            @click="handleAddCustomer">
            Change Policyholder
          </v-button>
        </template>
      </div>

      <div class="box policy-content">
        <h3>Business Information</h3>
        <div class="form-item form-item__raido">
          <span>Type</span>
          <el-form-item
            ref="class_id"
            :rules="isEdit?[]:rules.select"
            prop="class_id">
            <v-radio-group
              v-model="formData.class_id"
              border
              :list="newSmeProductOption">
              <template
                slot-scope="{ item }"
                name="extra">
                <span>
                  <span><font-awesome-icon :icon="item.icon"></font-awesome-icon></span>
                  <span class="mg-l-5">{{item.name}}</span>
                </span>
              </template>
            </v-radio-group>
          </el-form-item>
        </div>

        <div
          class="form-item form-half">
          <span>Business Nature</span>
          <el-form-item
            v-if="formData.class_id!=89"
            ref="bus_nature"
            :rules="isEdit?[]:rules.select"
            :prop="isEdit?'':'bus_nature'"
          >
            <v-select
              v-model="formData.bus_nature"
              :list="SMENatureTime" />
          </el-form-item>
          <el-form-item
            v-else
            ref="bus_nature"
            :rules="isEdit?[]:rules.input"
            :prop="isEdit?'':'bus_nature'"
          >
            <v-input
              v-model="formData.bus_nature"
              key-non-chinese></v-input>
          </el-form-item>
        </div>
        <div class="form-item ">
          <span>Is it a newly established company?</span>
          <el-form-item
            ref="newly_com_ind"
            :rules="isEdit?[]:rules.select"
            prop="newly_com_ind">
            <v-radio-group
              v-model="formData.newly_com_ind"
              :block="true"
              :list="smeYesNoOptions" />
          </el-form-item>
        </div>
        <div class="form-item form-half">
          <span>What is sum insured of Contents? (including furniture, fixtures, fittings, machinery & equipment) </span>
          <el-form-item
            ref="contents_isrd"
            :rules="isEdit?{}:rules.input"
            prop="contents_isrd">
            <v-input
              v-model="formData.contents_isrd"
              :keyNumber="true"
              :int="true"
              maxlength="7"
              prepend="HK$" />
          </el-form-item>
        </div>
        <div class="form-item">
          <span class="sme--content__tip ">
            Excludes articles brittle in nature / plate glass
          </span>
        </div>
        <div
          class="form-item form-half">
          <span>What is the sum insured of stock?</span>
          <el-form-item
            ref="stocks_isrd"
            :rules="isEdit?[]:rules.input"
            prop="stocks_isrd">
            <v-input
              v-model="formData.stocks_isrd"
              :keyNumber="true"
              :int="true"
              prepend="HK$"/>
          </el-form-item>
        </div>
        <div class="form-item">
          <span class="sme--content__tip ">
            Excludes stock of goods on consignment
          </span>
        </div>
      </div>
      <div class="box">
        <occuption-underwriting
          ref="occuption"
          is-new-sme
          :isEdit="isEdit"
          :classId="formData.class_id"
          :form="form"></occuption-underwriting>
      </div>
      <div class="travel-box box sme-container__info">
        <h2>Upload Document</h2>
        <div >
          <div class="flex flex-sb-center">
            <div class="form-item form-half">
              <span>Renewal Notice or 3rd Party Quotation</span>
              <el-form-item
                ref="renew_file"
                :rules="isEdit?[]:rules.upload"
                prop="renew_file">
                <file-container
                  :fileData="formData.renew_file"
                  :edit="true"
                  is-show-detail
                  :show-left-name="false"
                  is-none-name
                  :is-viewer="true"
                  :otherData="{
                    idKey:'renew_file_id',
                    target: 'renew_file'
                  }"
                  @uploadSuccess="handlerUploadSuccess"
                  @delete="handlerDeleteFile"
                />
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Business Registration Certificate</span>
              <el-form-item
                ref="br_file"
                :rules="isEdit?[]:rules.upload"
                prop="br_file">
                <file-container
                  :fileData="formData.br_file"
                  :edit="true"
                  is-show-detail
                  :show-left-name="false"
                  :is-viewer="true"
                  is-none-name
                  :otherData="{
                    idKey:'br_file_id',
                    target: 'br_file'
                  }"
                  @uploadSuccess="handlerUploadSuccess"
                  @delete="handlerDeleteFile">
                </file-container>
              </el-form-item>
            </div>
          </div>

        </div>
        <div class="table">
          <div class="th">Latest 3 months Contribution Record</div>

          <div
            v-for="(item, index) in formData.mpf_files"
            :key="index"
            class="tr">
            <file-container
              :key="index"
              :edit="true"
              is-table
              :fileData="item"
              :otherData="{
                index,
                target: 'mpf_files'
              }"
              titleName= "MPF Documents"
              @delete="handlerDeleteFile"
              @uploadSuccess="handlerUploadSuccess"
            />
          </div>
          <div
            v-if="formData.mpf_files.length<=0"
            class="tr">-</div>
        </div>
        <el-form-item
          ref="mpf_files"
          prop="mpf_files">
          <v-upload
            label="Add File"
            icon="plus"
            blue
            :otherData="{
              type: 'other',
              target: 'mpf_files'
            }"
            @uploadSuccess="handlerUploadSuccess" />
        </el-form-item>
      </div>

    </el-form>
    <attach-user
      ref="attach-user"
      :ticketId="ticketId"
      :isNewSME="true"
      is-share
      @shareUser="handleAttach"
    />
    <confirm-information
      ref="confirm-information"
      :upd_def_info="formData.updDefInfo"
      @confirm="handlerConfirmChangeInfo" />
  </div>
<!--  </lazy-dom>-->
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MixinRules from '@/mixins/rules'
import PolicyHolder from '@/views/quoting/sme/component/policy-holder-form'
import AttachUser from '@/views/quoting/dialogs/attachCustomer'
import {mapState} from 'vuex'
import {smeClassId} from '@/utils/smePath'
import OccuptionUnderwriting from './occuption-form'
import {SMEAttachedCustomer,editSMETicket} from '@api/new_sme'
import ConfirmInformation from '@/views/components/dialogs/confirm-information'

export default {
  name: 'smeKycForm',
  components: {
    OccuptionUnderwriting,
    PolicyHolder,
    AttachUser,
    ConfirmInformation
  },
  mixins: [MixinOptions, MixinFormat, MixinRules],
  props: {
    form: {
      type: Object,
      default: ()=>({})
    },
    formDataLock: {
      type: Number,
      default: 0
    },
    isQuote: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
  },
  data() {
    const checkSelect = (rule, value, callback) => {
      const field_arr = rule.field.split('.')||[]
      const target = field_arr[0]
      const val = field_arr[1]
      let selectVal = this.formData[target][val]
      if(selectVal<=0) {
        callback( new Error(this.$t('placeholder.select') ) )
      }
      callback()
    }
    const checkDateSelect = (rule, value, callback) => {
      let {pcy_cmnt_dt} = this.formData.policy_detail||{}
      if(!pcy_cmnt_dt) {
        callback( new Error(this.$t('placeholder.select') ) )
      }
      callback()
    }
    const needAttach = (rule, value, callback) => {
      let {customer_id} = this.formData||{}
      if(customer_id<=0) {
        console.log('customer_id00',customer_id)
        callback( new Error(this.$t('placeholder.select') ) )
      }
      callback()
    }
    const needUpload = (rule, value, callback) => {
      //"beauty , Hair Salon, Medical Center
      let need = [84,86,88].includes(this.classId)
      let {device_files=[]} = this.formData.upload_document
      if(device_files.length<=0&&need) {
        callback( new Error(this.$t('placeholder.upload') ) )
      }
      callback()
    }
    const checkSelectTime = (rule, value, callback) => {
      let startTime = this.startTime
      let endTime = this.endTime
      if(!startTime||!endTime) {
        callback( new Error(this.$t('placeholder.select') ) )
      }
      callback()
    }
    return {
      showSMS:false,
      oldFormDataLock: -1,
      cusFormDataLock: 0,
      formParams:{},
      formData: {
        less_verify_save: 0, // 是否僅保存部分資料（1：部分保存；0：全部保存   --标记是create 还是 edit
        newly_com_ind:'',
        isrd_com_nm:'',
        id_no:'',
        phone_no:'',
        email:'',
        bsns_nature_id:'',

        addr_room: '',
        addr_floor: '',
        addr_block: '',
        addr_building: '',
        addr_street: '',
        addr_district: '',
        addr_area: '',
        addr_region: '',

        corr_address:{
          addr_room: '',
          addr_floor: '',
          addr_block: '',
          addr_building: '',
          addr_street: '',
          addr_district: '',
          addr_area: '',
          addr_region: '',
        },
        contact_nm:'',
        contact_phone:'',

        bus_nature:'',
        contents_isrd:'',
        stocks_isrd:'',
        class_id:'',
        br_file:{},
        br_file_id:'',
        renew_file:[],
        renew_file_id:'',
        mpf_files:[],
        customer_id:''
      },
      subForm: {
        'policy-holder': false,
      },
      rules: {
        timeRequired: [
          {validator: checkDateSelect,message: this.$t('placeholder.select'), trigger: ['blur','change'] },
        ],
        smeSelect: [
          {validator: checkSelect,message: this.$t('placeholder.select'), trigger: ['blur','change',] },
        ],
        select_time: [
          {validator: checkSelectTime,message: this.$t('placeholder.select'), trigger: ['change', 'blur'] },
        ],
        document_upload:[
          {validator: needUpload,message: this.$t('placeholder.upload'), trigger: ['change', 'blur'] },
        ],
        customer_id:[
          {validator: needAttach,message: this.$t('placeholder.select'), trigger: ['change', 'blur'] },
        ]
      },

    }
  },
  computed: {
    ...mapState('smeQuote', ['smeQuickForm']),
    SMENatureTime(){
      let {class_id=81} = this.formData||{}
      return this[`SMENatureTime_${class_id}`]
    },
    SMEJobRoleOption(){
      let {class_id=81} = this.formData||{}
      return this[`SMEJobRoleOption_${class_id}`]
    },
    ticketId() {
      let {ticket_id} =this.$route.query||{}
      return ticket_id
    },
    type(){
      let {type} = this.$route.params
      return type
    },
    orderId(){
      let {order_id} = this.$route.query||{}
      return order_id
    },
    productId(){
      let {product_id} = this.$route.query||{}
      return product_id||this.form.class_id
    },
    isAttachCustomer(){
      let {customer_id}=this.formData||{}
      return customer_id>0
    },
    policyholder_detail(){
      let {policyholder_detail={}} =this.form||{}
      return policyholder_detail||{}
    },
    isRules(){
      return this.checkRefer ===2
    },
  },
  watch: {
    // 表單鎖，外層會更新，數值變化了才可以更新 formData
    formDataLock: {
      handler(val, old = -1) {
        if(val !== old) {
          this.oldFormDataLock = old
        }
      }
    },
    form: {
      immediate: true,
      deep:true,
      handler(val) {
        if (val) {
          // if(this.formDataLock !== this.oldFormDataLock) {
          //   // 觸發更新就賦值，避免二次更新
          //   this.oldFormDataLock = this.formDataLock
          Object.keys(this.formData).some(key => {
            if (key in val) {
              this.formData[key] = JSON.parse(JSON.stringify(val[key]))
            }
          })
        }
        let {
          addr_room,
          addr_floor,
          addr_block,
          addr_building,
          addr_street,
          addr_district,
          addr_area,
          addr_region} = val||{}
        this.formData.corr_address = {
          addr_room,
          addr_floor,
          addr_block,
          addr_building,
          addr_street,
          addr_district,
          addr_area,
          addr_region
        }
        // }
      }
    },
  },
  created() {
  },
  methods: {
    handlerConfirmChangeInfo(result,params) {
      if (result) {
        this.formParams.upd_def_addr = 1 // 標記需要更新常置資料
      }
      this.$emit('getFormData', this.formParams)
    },
    handleAttach(id,data){
      this.network().SMEAttachedCustomer({customer_id:id})
    },
    handleAddCustomer(){
      this.$refs['attach-user'].showAttachCustomer()
    },
    handleChange(val,name) {
      this[name] = val
    },
    checkDisabled(field) {
      const { disable_filed = [] } = this.form||{}
      return disable_filed.includes(field)&&this.form[field]!=''
    },
    lessSubmitForm(otherData = {}){
      this.otherData = otherData
      let {policy_detail={}} = this.formData
      let {same_as_corr_addr_ind} = policy_detail
      let subForm = this.subForm
      Object.keys(subForm).some(key => {
        this.subForm[key] = false
        this.$refs[key].submitFormNoVaild(key)
      })
      const result = {
        ...this.formData,
      }

      this.$emit('getFormData', result, otherData)

    },
    submitForm(otherData = {}) {
      let subForm = this.subForm
      this.$refs['form'].validate(async(valid, rules) => {
        if(valid) {
          if(this.isAttachCustomer){
            Object.keys(subForm).some(key => {
              subForm[key] = false
              this.$refs[key].submitForm(key)
            })
            if(Object.values(this.subForm).some(item => item === false)) {
              return
            }
          }

          let data = await this.$refs.occuption.submitForm()
          const result = {
            ...this.formData,
            ...data,
            save_request:this.isEdit?0:1
          }
          const {updDefInfo = []} = this.formData
          this.formParams = result
          if (updDefInfo && updDefInfo.length > 0) {
            this.$refs['confirm-information'].changeDialog()
          } else {
            this.handlerConfirmChangeInfo()
          }
          // this.$emit('getFormData', result, otherData)
        }
        else {
          this.scrollToValidDom(rules)
        }
      })

    },
    getSubimitForm(form, data) {
      // debugger
      this.subForm[form] = true
      let {corr_address} =data||{}
      this.formData = {
        ...this.formData,
        ...data,
        ...corr_address
      }
    },
    handlerUploadSuccess({ data, result, otherData }) {
      const { idKey, nameKey, target, index = '', type } = otherData
      const { id, path,thumb_url,url } = data
      if(target !== 'mpf_files') {
        this.$set(this.formData,target,data)
        this.$set(this.formData,idKey,id)
      }
      else {
        this.formData[target].push(data)
      }
    },
    handlerDeleteFile(otherData) {
      let { type, index,target } = otherData
      if(target !== 'mpf_files') {
        this.formData[target]={}
      }else {
        this.formData[target].splice(index,1)
      }
    },

    network(){
      return{
        SMEAttachedCustomer: async ({customer_id}) => {
          const {data} = await SMEAttachedCustomer({
            customer_id,
            ticket_id:this.ticketId
          })
          let {
            addr_room,
            addr_floor,
            addr_block,
            addr_building,
            addr_street,
            addr_district,
            addr_area,
            addr_region} = data||{}
          let corr_address = {
            addr_room,
            addr_floor,
            addr_block,
            addr_building,
            addr_street,
            addr_district,
            addr_area,
            addr_region
          }
          this.formData = {
            ...this.formData,
            ...data,
            corr_address,
            customer_id
          }
          this.cusFormDataLock += 1
        },

      }
    },
  }
}
</script>
<style lang="scss" scoped>
@import "../../quoting/sme/info";
/deep/.policy-form{
  width: 690px!important;
}
.policy-form{
  width: 690px!important;
  max-width: 690px;
  .box {
    padding-bottom: 15px;
    margin-bottom: 30px;
    border-bottom:1px solid #D1D5DA;;
    &.border-none{
      border-bottom: 0;
    }
    .circle-icon{
      margin-right: 8px;
      width: 18px;
      height: 18px;
      border-radius: 30px;
      background: #D73A49;
      display: flex;
      color: white;
      font-weight: 600;
      justify-content: center;
      align-items: center;
    }
    h3{
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #24292E;
    }
  }
  .travel-box{
    .flex{
      flex-wrap: wrap;
    }
  }
  .margin-top{
    margin-top: 10px;
  }
  .gray{
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #24292E;
    display: inline-block;
  }
}
/deep/ .max-content{
  width: max-content;
}
.select-time{
  .el-date-editor{
    width: 100%;
  }
}
.form-item{
  .sme--content__tip{
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #586069;
    padding-bottom: 0;
  }
  >span{
    &:first-child {
      display: block;
      padding-bottom: 8px;
    }
  }
  &.form-item__raido{
    /deep/.el-radio-group{
      .el-radio{
        width: calc(50% - 10px);
        margin-left: 0;
        margin-bottom: 8px;
      }
    }
  }
}
.table{
  .th{
    font-size: 14px;
    padding: 8px 16px!important;
  }
  .tr{
    display: flex;
    justify-content: space-between;
    padding:10px 16px;
    span{
      flex: none;
    }
    .blue {
      color: #409EFF!important;
    }
  }
}
</style>
